var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6024_1442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9368 11.0042V5.69651C16.9368 4.52344 16.4694 3.39841 15.6374 2.56893C14.8055 1.73944 13.6771 1.27344 12.5005 1.27344C11.324 1.27344 10.1956 1.73944 9.36363 2.56893C8.53167 3.39841 8.06429 4.52344 8.06429 5.69651V11.0042M21.4984 7.65349L22.9925 21.8073C23.0753 22.5917 22.4602 23.2734 21.6687 23.2734H3.3323C3.14563 23.2736 2.96101 23.2347 2.79042 23.1591C2.61984 23.0835 2.46711 22.973 2.34216 22.8347C2.2172 22.6965 2.12282 22.5336 2.06514 22.3566C2.00745 22.1795 1.98776 21.9924 2.00734 21.8073L3.50265 7.65349C3.53714 7.32743 3.69149 7.02565 3.93592 6.80633C4.18036 6.58701 4.49758 6.46569 4.82642 6.46575H20.1746C20.856 6.46575 21.4274 6.97882 21.4984 7.65349ZM8.50791 11.0042C8.50791 11.1215 8.46117 11.234 8.37797 11.317C8.29478 11.3999 8.18194 11.4465 8.06429 11.4465C7.94663 11.4465 7.83379 11.3999 7.75059 11.317C7.6674 11.234 7.62066 11.1215 7.62066 11.0042C7.62066 10.8869 7.6674 10.7744 7.75059 10.6914C7.83379 10.6085 7.94663 10.5013 8.06429 10.5013C8.18194 10.5013 8.29478 10.5479 8.37797 10.6309C8.46117 10.7138 8.50791 10.8869 8.50791 11.0042ZM17.3804 11.0042C17.3804 11.1215 17.3336 11.234 17.2505 11.317C17.1673 11.3999 17.0544 11.4465 16.9368 11.4465C16.8191 11.4465 16.7063 11.3999 16.6231 11.317C16.5399 11.234 16.4931 11.1215 16.4931 11.0042C16.4931 10.8869 16.5399 10.7744 16.6231 10.6914C16.7063 10.6085 16.8191 10.5619 16.9368 10.5619C17.0544 10.5619 17.1673 10.6085 17.2505 10.6914C17.3336 10.7744 17.3804 10.8869 17.3804 11.0042Z",
    stroke: "#5281CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6024_1442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.273438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.675cee4cf7ecc7c1ec3249a6b4a2e61e.svg";
export { ForwardRef as ReactComponent };